export const reverseObject = (object) => {
  const retobj = {};
  for (var key in object) {
    retobj[object[key]] = key;
  }
  return retobj;
};

// returns parsed object out of stringified object
export const parseStringifiedJsonObj = (strObj) => {
  try {
    const obj = JSON.parse(strObj);

    return obj;
  } catch (error) {
    return {};
  }
};
